export const APP_STORE_URL = 'https://apps.apple.com/us/app/michelangelo-vibe-coding/id6744751580';

export const LINKS = {
  docs: 'https://docs.michelangelo.land',
  discord: 'https://discord.com/invite/RJDhCzA7Hv',
  github: 'https://github.com/michelangelo-land',
  x: 'https://x.com/michelangelo_os',
  linkedin: 'https://www.linkedin.com/company/michelangelo-land',
  producthunt: 'https://www.producthunt.com/products/michelangelo',
} as const;

export const NAV_ITEMS = [
  { id: 'manifesto', label: 'Manifesto' },
  { id: 'product', label: 'Product' },
  { id: 'platforms', label: 'Platforms' },
  { id: 'imaginer', label: 'Imaginer' },
] as const;

export type NavSectionId = (typeof NAV_ITEMS)[number]['id'];
export type Route = '/' | '/privacy' | '/terms' | '/preview';
